export default "__VITE_ASSET__bfab5818__"